import * as yup from "yup";

const civilServiceSchema = yup.object({
    accreditation: yup.string().trim().required("accreditation is required.")
});

export default civilServiceSchema;
